import React from 'react';
import { createFeature } from '@edreamsodigeo/frontend-core';
import { Box } from '@edreamsodigeo/prisma-design-system';

import { calculateTravelDays } from '@/clientState/commonFunctions';
import useItineraryFromUrl from '@/clientState/hooks/useItineraryFromUrl';
import HotelVoucherCard from '@/components/FlightSummary/HotelVoucher/HotelVoucherCard';
import type { HotelDealsComponentABProps } from '@/components/FlightSummary/MapItinerary/types';
import { SHOW_BAGS_SEATS_NEGATIVE_MARKUP_FLIGHT_SUMMARY } from '@/versionedComponents';

const HotelDealsWithProps: React.FC<HotelDealsComponentABProps> = ({
  idx,
  isRoundTrip,
  segments,
  destinationName,
  HotelDeals,
}) => {
  const amountNights = isRoundTrip
    ? calculateTravelDays({
        startSegment: segments[0],
        endSegment: segments[1],
      })
    : 0;

  const { highlightOffer = false } = useItineraryFromUrl();

  if (highlightOffer && idx === 0) {
    return (
      <Box mx="minus_big">
        <HotelVoucherCard {...{ amountNights, destinationName }} />
      </Box>
    );
  }

  return isRoundTrip && idx === 0 ? (
    <Box mx="minus_big">
      {HotelDeals ? (
        <HotelDeals {...{ amountNights, destinationName, segments }} />
      ) : null}
    </Box>
  ) : null;
};

const BagsSeatsNegativeMarkupWithProps: React.FC<
  HotelDealsComponentABProps
> = ({ idx, bagsSeatsNegativeMarkup }) => {
  return idx === 0 ? <Box mx="minus_big">{bagsSeatsNegativeMarkup}</Box> : null;
};

export const BagsSeatsNegativeMarkupComponentAB: React.FC<HotelDealsComponentABProps> =
  createFeature({
    name: SHOW_BAGS_SEATS_NEGATIVE_MARKUP_FLIGHT_SUMMARY,
    variations: [HotelDealsWithProps, BagsSeatsNegativeMarkupWithProps],
    version: 1,
  });
